import { Component, OnInit, ViewChild, Inject,InjectionToken} from "@angular/core";
import { MatTableDataSource, MatSort, MatSortHeader } from "@angular/material";
import { IngresoService } from "../services/ingreso.service";
import { DRenta210IngresoServicios } from "@dian-api/renta210-ingreso";
import { Borradores } from "../models/borradores";
import { DInfoResumenFormulario, DListaDocumentos } from "@dian/api-formulario";
import { DNotificacionServicio } from "@dian-cmp/notificaciones";
import { ModalService, ModalType } from "../../modal/services/modal.service";
import { DOperacionesGeneralesIngresoServicio } from "@dian-cmp/formulario";
import { MatDialog } from "@angular/material";
import { GeneralService } from "../../services/general.service";
import { DContextoMuisca } from "@dian/core";
import { IDFormularioIngreso } from "@dian/api-formulario";
import { DRespuestaSimple, DError } from "@dian/core";
import { DMensajes } from "@dian-cmp/formulario";
import { ModoDiligenciemientoComponent } from "../shared/modals/modo-diligenciemiento/modo-diligenciemiento.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Buffer } from 'buffer';

@Component({
  selector: "app-borradores",
  templateUrl: "./borradores.component.html",
  styleUrls: ["./borradores.component.css"],
  providers: [DRenta210IngresoServicios],
})
export class BorradoresComponent implements OnInit {
  dataBorradores: Borradores[] = [];
  displayedColumns = ["num_formulario", "anio", "tipo", "estado", "acciones"];
  dataSource = new MatTableDataSource(this.dataBorradores);
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
  sortAsc = "/assets/img_flecha";
  private enProceso: boolean = true;
  private arrDocumentosDiligenciamiento: DListaDocumentos;
  private hayFraccion: boolean = false;
  private hayInicial: boolean = false;
  private operacionesGenerales: DOperacionesGeneralesIngresoServicio;
  datosUsuario: DContextoMuisca;
  anioSugerida: number;
  identificadoresDocumentos : any;

  private estadosCarga = {
    pendientes: false,
    presentados: false,
    definitivos: false,
    anios: false,
  };
  constructor(
    private ingresoService: IngresoService,
    private dServicioRESTAPI: DRenta210IngresoServicios,
    private dNotificacionServicio: DNotificacionServicio,
    private modalService: ModalService,
    private dialog: MatDialog,
    private generalService: GeneralService,
    private route : ActivatedRoute,
    private router: Router
  ) {
    this.operacionesGenerales = new DOperacionesGeneralesIngresoServicio(
      this.dNotificacionServicio,
      this.dServicioRESTAPI,
      this.dialog
    );

    this.arrDocumentosDiligenciamiento = new DListaDocumentos();
    this.generalService.datosRespuesta$.subscribe((res) => {
      this.datosUsuario = res;
    });
    this.obtenerDocsPendientes();
  }

  ngOnInit() {
    if (!this.datosUsuario) {
      this.datosUsuario = this.generalService.getDatosUsuario();
    }
    
    this.route.queryParams.subscribe(params => {
      const paramValue = params['idRequest'];
      if(paramValue){
        const decodedBuffer = Buffer.from(paramValue, 'base64');
        const decodedString = decodedBuffer.toString('utf-8');
        this.anioSugerida = parseInt(decodedString.split('=')[1]);
      }
    });
  }

  ngAfterViewInit() {
  }

  /**
   * @desc Funcion para obtener los documentos pendientes
   */
  public obtenerDocsPendientes() {
    this.dataSource.data = this.dataBorradores;
    this.enProceso = true;
    let precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    let observableDiligenciamiento =
      this.dServicioRESTAPI.consultarFormulariosEstado("pendiente");
    observableDiligenciamiento.subscribe(
      (res) => {
        this.dataBorradores = res.listadoFormularios.infoFormularios;
        this.identificadoresDocumentos = res.idetificadoresDocumentos;
        this.arrDocumentosDiligenciamiento = <DListaDocumentos>(
          res.listadoFormularios
        );
        this.arrDocumentosDiligenciamiento.infoFormularios.forEach(
          (item, index) => {
            if (
              item.modo === "fraccion" ||
              item.modo === "fraccion_correccion"
            ) {
              this.hayFraccion = true;
            }
            if (item.modo === "inicial" || item.modo === "correccion") {
              this.hayInicial = true;
            }
          }
        );
        if (this.anioSugerida && this.arrDocumentosDiligenciamiento && this.arrDocumentosDiligenciamiento.infoFormularios.length && this.arrDocumentosDiligenciamiento.infoFormularios.length > 0) {
          const sugerida = this.arrDocumentosDiligenciamiento.infoFormularios.find(item => item.anio === this.anioSugerida);
          //this.editarFormulario(sugerida);
        }
        this.estadosCarga.pendientes = true;
        this.dataSource.data = this.dataBorradores;
        //  this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case "num_formulario":
              return item.identificador["id"];
            case "tipo":
              const modo =
                item["modo"] === "fraccion_correccion"
                  ? "Corrección fraccion"
                  : item["modo"];
              return modo;

            case "estado":
              return item.atributos.docAtributos.enProcesoFirmas;
            case "anio":
              return item["anio"];

            default:
              return item[property];
          }
        };
        precarga.close();
      },
      (error) => {
        this.estadosCarga.pendientes = true;
        if (error.mensaje === 'Documentos no encontrados' )  this.dataSource.data = [];
        precarga.close();
      }
    );

    this.validarCargaCompletaFormulario(precarga);
  }

  /**
   * @desc Funcion para validar si el formulario esta completamente cargado y remover la animacion de precarga
   * @ignore
   */
  private validarCargaCompletaFormulario(precarga) {
    let intervalId = setInterval(() => {
      let bandera = true;
      let atributos = Object.keys(this.estadosCarga);

      for (let i in atributos) {
        if (!this.estadosCarga[atributos[i]]) {
          bandera = false;
          break;
        }
      }

      if (bandera) {
        this.enProceso = true;
        precarga.close();
        clearInterval(intervalId);
      }
    }, 500);
  }

  /**
   * @description Funcion para mostrar modal de confirmación para anular formulario
   * @param objetoFormulario formulario que se desea anular
   */
  confirmarAnulacion(objetoFormulario: DInfoResumenFormulario) {
    /* let confirmacion = this.dNotificacionServicio.mostrarDialogoConfirmacion("Señor Contribuyente: Al oprimir “Confirmar” se procede con la anulación del borrador de esta declaración y debe realizar un nuevo diligenciamiento");

    confirmacion.afterClosed().subscribe(
        res=>{
            if(res){
             //   this.anularFormulario(objetoFormulario);
            }                
        }
    ); */

    const configBody = {
      title: "",
      message: "¿Está seguro de anular la declaración?",
      main_button: "Sí",
      secondary_button: "No",
      info_message:
        "Al anular esta declaración, inicia un nuevo diligenciamiento.",
      main_action: "accept",
      text_align: "text-center",
      width: "500px",
      button_align: "text-center",
      current_icon: "./assets/img/modal_v2/e-info.png",
      onMainAction: () => {
        this.anularFormulario(objetoFormulario);
      },
      onSecondaryAction: () => {},
    };

    this.modalService.show(ModalType.SUCESS, configBody);
  }

  /**
   * @description Funcion para anular formulario
   * @param objetoFormulario formulario que se desea anular
   */
  anularFormulario(objetoFormulario: DInfoResumenFormulario) {
    let ideDocumento = String(objetoFormulario.identificador.id);
    let observableVersionFormato =
      this.dServicioRESTAPI.anularFormulario(ideDocumento);
    let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    observableVersionFormato.subscribe(
      (res) => {
        precargaProceso.close();
        this.enProceso = false;
        this.enProceso = false;
        const configBody = {
          title: "",
          message: `Declaración anulada con éxito`,
          main_button: "Cerrar",
          secondary_button: "",
          info_message: "",
          main_action: "accept",
          text_align: "text-center",
          width: "650px",
          button_align: "text-center",
          current_icon: "./assets/img/modal_v2/exito.png",
          onSecondaryAction: () => {},
        };
        this.modalService.show(ModalType.SUCESS, configBody);
        this.arrDocumentosDiligenciamiento = new DListaDocumentos();
        this.obtenerDocsPendientes();
      },
      (error) => {
        precargaProceso.close();
        this.enProceso = false;
        const body = {
          title: "Error",
          current_icon: "./assets/img/modal_v2/e-peligro.png",
          error_message: `No fue posible eliminar el documento: ${objetoFormulario.identificador.id}`,
          main_button: "",
          text_align: "text-center",
          list_content: [],
          main_action: "accept",
          link_message: "",
          onMainAction: () => {},
        };
        this.modalService.show(ModalType.WARNING, body);
      }
    );
  }

  /**
   * @desc Funcion para imprimir el formulario
   */
  imprimirFormulario(idDocumento: string) {
      this.operacionesGenerales.imprimirFormulario(idDocumento);
  }

  editarFormulario(objFormulario: DInfoResumenFormulario) {
     /////////////////Habilitar no experto >= 2022
    if (objFormulario && (objFormulario.anio === 2022 || objFormulario.anio === 2023) && (objFormulario.modo !== 'fraccion' && objFormulario.modo !== 'fraccion_correccion')) {
      this.mostrarModoDiligenciamientoModal(objFormulario);
       if (objFormulario.atributos && objFormulario.atributos.docAtributos && `${objFormulario.atributos.docAtributos.estado}` === '6') {
         this.mostrarModoDiligenciamientoModal(objFormulario);
       } else {
         const tmpFormulario = this.identificadoresDocumentos.find((item => `${item.idDocumento}` === `${objFormulario.identificador.id}`));
         if (tmpFormulario) {
           const cadClaveNegocio = tmpFormulario.cadClaveNegocio.split(';').filter(elemento => elemento.trim() !== '').find(elemento => elemento.includes('336'));
           const claveNegocio336 = (cadClaveNegocio && cadClaveNegocio.split('=')[1] && cadClaveNegocio.split('=')[1] !== '0') ? cadClaveNegocio.split('=')[1] : '16500002';
           objFormulario['modoNoExperto'] = claveNegocio336 === '16500003' ? true : false;
           this.generalService.enviarEditarFormulario(objFormulario);
         } else {
           this.generalService.enviarEditarFormulario(objFormulario);
         }
       }
    }else{
      this.generalService.enviarEditarFormulario(objFormulario);
    }
  }

  mostrarModoDiligenciamientoModal(objFormulario: DInfoResumenFormulario) {
    let config = {
      disableClose: true,
      maxWidth: '400px',
      data: {}
    };
    let dialogRef = this.dialog.open(ModoDiligenciemientoComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const tmpFormulario = this.identificadoresDocumentos.find((item => `${item.idDocumento}` === `${objFormulario.identificador.id}`));
        if (tmpFormulario) {
          const cadClaveNegocio = tmpFormulario.cadClaveNegocio.split(';').filter(elemento => elemento.trim() !== '').find(elemento => elemento.includes('336'));
          const claveNegocio336 = (cadClaveNegocio && cadClaveNegocio.split('=')[1] && cadClaveNegocio.split('=')[1] !== '0') ? cadClaveNegocio.split('=')[1] : '16500002';
          const modoDiligenciamientoDominio = result === 'noExperto' ? '16500003' : '16500002';
          objFormulario['modoNoExperto'] = result === 'noExperto' ? true : false;
          claveNegocio336 === modoDiligenciamientoDominio ? this.generalService.enviarEditarFormulario(objFormulario) : this.mostrarDialogoCambioModoDiligenciamiento(objFormulario);
        } else {
          objFormulario['modoNoExperto'] = result === 'noExperto' ? true : false;
          console.log('obj: ', objFormulario);
          this.generalService.enviarEditarFormulario(objFormulario);
        }
      }
    });
  }

  mostrarDialogoCambioModoDiligenciamiento(objFormulario: DInfoResumenFormulario) {
    const configBody = {
      title: 'Advertencia',
      message: 'Usted va a cambiar el modo de diligenciamiento, ¿Está seguro que desea continuar?',
      main_button: "Aceptar",
      secondary_button: "Cancelar",
      onMainAction: ()=>{this.generalService.enviarEditarFormulario(objFormulario);}
     }
     this.modalService.show(ModalType.INFO, configBody);
  }


}



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/borradores/borradores.component.ts